import { ChatPanel } from "@neu/libui";

export const Chat = () => <ChatPanel />;
